function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currentColor}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_2-2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M4.609 5.514h3v3h-3zM8.809 5.514h10.6v3h-10.6zM4.609 13.864h3v3h-3zM4.609 22.214h3v3h-3zM8.809 16.864h4.539a5.606 5.606 0 01.252-.725l.585-1.35 2.074 2.075h2.028l-3-3H8.809zM8.809 25.214h10.6v-1.041c-.154.012-.307.032-.463.032a5.817 5.817 0 01-4.384-1.991H8.809z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M21.509 27.614h-18.4v-24.4h18.4V13.24a5.85 5.85 0 012 1.606V1.214h-22.4v28.4h22.4v-2.673l-2-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M21.509 17.257v.02l.009-.01-.009-.01z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M30.815 27.967a2.235 2.235 0 00-1.991-1.645l.068-.067-2.092-2.092-3.475-3.475a4.824 4.824 0 00.343-.978 4.641 4.641 0 00.122-1.062 4.745 4.745 0 00-1.412-3.381 4.829 4.829 0 00-5.429-.955l1.59 1.59 1.59 1.59-.7 1.724-1.724.7-1.579-1.579-1.58-1.58a4.752 4.752 0 00-.289.91 4.693 4.693 0 00-.1.977 4.751 4.751 0 001.412 3.382 4.824 4.824 0 003.408 1.4 4.81 4.81 0 001.867-.373l3.5 3.505 2.074 2.074a2.238 2.238 0 104.4-.669zm-.948.877l-.014.052a1.2 1.2 0 01-.852.851l-.052.014a1.2 1.2 0 01-1.163-.311l-.038-.038a1.206 1.206 0 01-.312-1.163l.014-.053a1.2 1.2 0 01.852-.851l.052-.014a1.206 1.206 0 011.163.312l.038.038a1.2 1.2 0 01.312 1.163z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h32v32H0z"
})));

var SvgJobsmin = function SvgJobsmin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJobsmin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Jobs.min.47e2215b.svg";
export { ForwardRef as ReactComponent };